import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";
import { Utils } from "src/modules/utils/shared/utils";
import { TableCell } from "./table-cell.model";
import { ToolTipDefinition } from "./ToolTipDefinition.model";
import { TableCellEvent } from "./table-cell-event.model";
import { MenuItem } from "primeng/api";

export class TableRow<T = any> {

    id: string;
    path: string[];
    raw: T;
    values: OrdinaryObject;
    style: string;
    styleClass: string;
    height: number = null;
    toolTip: ToolTipDefinition;
    virtual = false;
    canHaveChildren = false;
    canDrag = true;
    canDeleteInternal: boolean | ((row: TableRow) => boolean) = true;
    getContextMenuItems: (value: TableCellEvent) => MenuItem[];
    
    constructor(id: string, raw: T, values: OrdinaryObject = null, props?: Partial<TableRow>) {
        this.id = id;
        this.raw = raw;
        this.values = values ?? raw;
        if (props != null) {
            Object.assign(this, props);
        }
    }

    canDelete(): boolean {
        return Utils.isFunction(this.canDeleteInternal) ? (this.canDeleteInternal as any)(this) : this.canDeleteInternal as boolean;
    }

    getValue(key: string): any {
        return this.values[key] instanceof TableCell ? this.values[key].value : this.values[key];
    }

}
